import { Injectable } from '@angular/core';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { HelperUtilsService } from './helper-utils.service';
import { ProcessService } from './process.service';

/** ValidationService */
@Injectable({
    providedIn: 'root',
  })
export class ValidationService {

    /** attributesMap */
    public attributesMap;
    // private currentStep:string;

    /**
     * constructor
     * @param helper
     * @param processService
     * @param helperUtilsService
     */
    public constructor (private helper: Helper, private processService: ProcessService, private helperUtilsService: HelperUtilsService) {
        this.attributesMap = [];
    }

    // create interface attribute

    /** getAttribute */
    public getAttribute (attrName: string, isBEValidation: boolean) {

        if (isBEValidation) {
            if (this.attributesMap[this.processService.getCurrentStep()] && this.attributesMap[this.processService.getCurrentStep()][attrName]) {
                return this.attributesMap[this.processService.getCurrentStep()][attrName].validationRegex || '';
            } else {
                return '';
            }
        } else {
            return this.helper.getRegexByKey(attrName) || '';
        }
    }

    /** addStepAttributes */
    public addStepAttributes (parametersObject, stepName: string) {
        // TODO add attr to the attributesMap
        // this.setCurrentStep(stepName);
        if (typeof (parametersObject) == 'object') {
            this.attributesMap[stepName] = parametersObject;
        } else if (parametersObject instanceof Array) {
            this.attributesMap[stepName] = parametersObject[0];
        } else {
            // TODO handle error
        }

    }

}
